<swb-file-browse [browseConfig]="{ imgOnly: true, isSingle: true }" origin="mce"></swb-file-browse>